import { Color, Spacing } from '@persona-id/design-tokens';
import { StarFillIcon } from '@persona-id/design-tokens/icons';
import { ChangeEvent } from 'react';
import styled from 'styled-components';

import DynamicInput from 'dashboard/components/DynamicInput';
import NavBack from 'dashboard/components/NavBack';
import { FullScreenHeaderContainer } from 'dashboard/layouts/ShowViewLayoutV2';
import { Role } from 'dashboard/models/role';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { HStack } from 'design-system/components/Stack';
import Sticker from 'design-system/components/Sticker';

interface RoleHeaderProps {
  canEditRoleAttributes: boolean;
  canUpsell: boolean;
  isDirty: boolean;
  onUpdateRole: () => Promise<void>;
  title: string;
  role: Role;
  setRoleName: (name: string) => void;
  showDeactivateRoleModal: () => void;
}

const RoleHeader = ({
  title,
  role,
  isDirty,
  canEditRoleAttributes,
  canUpsell,
  onUpdateRole,
  setRoleName,
  showDeactivateRoleModal,
}: RoleHeaderProps) => {
  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setRoleName(event.target.value);
  };

  return (
    <FullScreenHeaderContainer>
      <LeftHeaderContainer>
        <NavBack to='/dashboard/user-roles' />
        {canUpsell ? (
          <>
            {title}
            <Spacer width={1} />
            <LimitedStickerContainer data-marketing-id='roles-limited-badge'>
              <Sticker variant='teal' icon={<StarFillIcon color={Color.PrimaryBlack} />}>
                Limited
              </Sticker>
            </LimitedStickerContainer>
          </>
        ) : (
          <DynamicInput
            disabled={!canEditRoleAttributes}
            value={title}
            onChange={handleNameChange}
          />
        )}
      </LeftHeaderContainer>
      {canEditRoleAttributes && (
        <HStack spacing={Spacing[2]}>
          {role.relationships.users.data.length === 0 && (
            <Button
              id='role-header__button--deactivate'
              name='role-header__button--deactivate'
              data-test='role-header__button--deactivate'
              onClick={showDeactivateRoleModal}
              variant='basic'
            >
              Deactivate
            </Button>
          )}
          <Button
            id='role-header__button--save'
            variant='primary'
            name='role-header__button--save'
            data-test='role-header__button--save'
            onClick={onUpdateRole}
            disabled={!isDirty || !canEditRoleAttributes}
          >
            Save
          </Button>
        </HStack>
      )}
    </FullScreenHeaderContainer>
  );
};

export default RoleHeader;

const LeftHeaderContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LimitedStickerContainer = styled.div`
  display: flex;
  margin-top: auto;
  margin-bottom: auto;
  cursor: default;
`;
